import { render, staticRenderFns } from "./ImportErrorsTab.vue?vue&type=template&id=65bfb795"
import script from "./ImportErrorsTab.vue?vue&type=script&lang=js"
export * from "./ImportErrorsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports